import React from "react";
import CarDetalle from './CarDetalle';

const CarHorarios = ({ materia, datos }) => {
  const horarios = datos || [];
  return (
    <div className="card">
        <div className="card-header">{materia}</div>
        <div className="card-body">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Día</th>
                    <th scope="col">Hora</th>
                    <th scope="col">Sección</th>
                  </tr>
                </thead>
                <tbody>
                      {
                      horarios.map((x, i)=>{
                        return (
                          <CarDetalle
                          key={i}
                          diasemana = {x.diasemana}
                          hora = {x.hora_inicio}
                          seccion = {x.seccion} />
                        )
                      })
                    }
                </tbody>
                </table>
            </div>
        </div>
    </div>
  );
};

export default CarHorarios;